import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { DEFAULT_CONTENT } from "../lib/siteContent";

const ContentContext = createContext(null);
export const useContent = () => useContext(ContentContext);

const CACHE_KEY = "mtl_content";
const readCache = () => {
  try {
    const c = JSON.parse(localStorage.getItem(CACHE_KEY));
    return c ? { ...DEFAULT_CONTENT, ...c } : DEFAULT_CONTENT;
  } catch { return DEFAULT_CONTENT; }
};

export function ContentProvider({ children }) {
  const [content, setContent] = useState(readCache);

  const refresh = () => api.get("/content")
    .then((r) => {
      setContent({ ...DEFAULT_CONTENT, ...r.data });
      try { localStorage.setItem(CACHE_KEY, JSON.stringify(r.data)); } catch {}
    })
    .catch(() => {});

  useEffect(() => { refresh(); }, []);

  return (
    <ContentContext.Provider value={{ content, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}
